import React from 'react';

export default function LogoMobileWhite() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="110"
      height="36"
      viewBox="0 0 110 36"
      fill="none"
    >
      <path
        d="M51.0232 12.6478C49.9006 11.5374 48.3364 10.9805 46.3274 10.9805H41.4219V13.3567H46.3274C46.9755 13.3567 47.5258 13.4574 47.974 13.6575C48.4188 13.8555 48.7846 14.1361 49.068 14.4996C49.3481 14.8619 49.5546 15.3058 49.682 15.8359C49.8127 16.367 49.8764 16.9563 49.8764 17.6027C49.8764 18.249 49.8028 18.8618 49.6567 19.3896C49.5073 19.9208 49.2789 20.3804 48.9669 20.765C48.655 21.1531 48.2453 21.4483 47.7433 21.6552C47.2413 21.8587 46.6372 21.9627 45.9243 21.9627H44.1602V15.5798H41.423V24.3378H45.8705C46.9359 24.3378 47.8927 24.1958 48.7385 23.9073C49.5809 23.6221 50.2993 23.1916 50.8881 22.6191C51.4757 22.0432 51.925 21.3409 52.2391 20.5023C52.5511 19.6669 52.707 18.6963 52.707 17.5859C52.707 15.4009 52.148 13.7571 51.0254 12.6466L51.0232 12.6478Z"
        fill="white"
      />
      <path
        d="M58.0849 21.9638V18.6717H63.9285V16.2764H58.0849V13.3567H64.2976V10.9805H55.3477V24.3378H64.0911L64.682 21.9616H58.0849V21.9638Z"
        fill="white"
      />
      <path
        d="M69.749 21.9638V18.6717H75.5926V16.2764H69.749V13.3567H75.9616V10.9805H67.0117V24.3378H75.7519L76.3461 21.9616H69.749V21.9638Z"
        fill="white"
      />
      <path
        d="M88.2254 13.5737C88.0695 13.0682 87.8026 12.6254 87.4148 12.243C87.0304 11.8639 86.5086 11.5564 85.854 11.3271C85.1993 11.0979 84.3656 10.9805 83.3649 10.9805H78.6758V24.3378H81.3779V19.5674H83.4385C84.4183 19.5674 85.229 19.4511 85.8737 19.2152C86.5163 18.9759 87.0315 18.6549 87.4159 18.2501C87.8037 17.8453 88.0706 17.3734 88.2265 16.8356C88.3792 16.301 88.455 15.7386 88.455 15.1526C88.455 14.6058 88.3792 14.078 88.2265 13.5737H88.2254ZM85.6497 16.0438C85.5826 16.2999 85.4585 16.5135 85.274 16.688C85.0895 16.8624 84.8412 17.0022 84.5304 17.0995C84.2151 17.2001 83.8219 17.2515 83.3441 17.2515H81.3757V13.2829H83.3243C83.801 13.2829 84.1986 13.3288 84.5106 13.4126C84.8225 13.4999 85.0697 13.6262 85.2542 13.7884C85.4388 13.9505 85.5662 14.1507 85.6387 14.3866C85.7123 14.6226 85.7496 14.8977 85.7496 15.2085C85.7496 15.5194 85.7145 15.7878 85.6475 16.0438H85.6497Z"
        fill="white"
      />
      <path
        d="M93.5576 21.9437V10.9805H90.8203V24.3378H99.1562L99.7702 21.9425H93.5576V21.9437Z"
        fill="white"
      />
      <path
        d="M107.097 10.9805L104.175 16.3894L101.342 10.9805H98.293L102.829 18.8942V24.3378H105.57V18.8942L109.999 10.9805H107.096H107.097Z"
        fill="white"
      />
      <path
        d="M21.7415 2.64918C21.7415 1.64128 20.9389 0.824219 19.9489 0.824219C18.9588 0.824219 18.1562 1.64128 18.1562 2.64918V23.8666C18.1562 24.8745 18.9588 25.6916 19.9489 25.6916C20.9389 25.6916 21.7415 24.8745 21.7415 23.8666V2.64918Z"
        fill="#F73753"
      />
      <path
        d="M15.6907 19.2273C15.6907 18.2194 14.8881 17.4023 13.8981 17.4023C12.9081 17.4023 12.1055 18.2194 12.1055 19.2273V32.6752C12.1055 33.6831 12.9081 34.5002 13.8981 34.5002C14.8881 34.5002 15.6907 33.6831 15.6907 32.6752V19.2273Z"
        fill="#F73753"
      />
      <path
        d="M27.7923 12.5007C27.7923 11.4928 26.9897 10.6758 25.9997 10.6758C25.0096 10.6758 24.207 11.4928 24.207 12.5007V22.3032C24.207 23.3111 25.0096 24.1282 25.9997 24.1282C26.9897 24.1282 27.7923 23.3111 27.7923 22.3032V12.5007Z"
        fill="#F73753"
      />
      <path
        d="M27.7923 27.5164C27.7923 26.5085 26.9897 25.6914 25.9997 25.6914C25.0096 25.6914 24.207 26.5085 24.207 27.5164C24.207 28.5243 25.0096 29.3413 25.9997 29.3413C26.9897 29.3413 27.7923 28.5243 27.7923 27.5164Z"
        fill="#F73753"
      />
      <path
        d="M15.6907 14.0632C15.6907 13.0553 14.8881 12.2383 13.8981 12.2383C12.9081 12.2383 12.1055 13.0553 12.1055 14.0632C12.1055 15.0711 12.9081 15.8882 13.8981 15.8882C14.8881 15.8882 15.6907 15.0711 15.6907 14.0632Z"
        fill="#F73753"
      />
      <path
        d="M33.847 15.1609C33.847 14.153 33.0444 13.3359 32.0543 13.3359C31.0643 13.3359 30.2617 14.153 30.2617 15.1609V20.7409C30.2617 21.7488 31.0643 22.5659 32.0543 22.5659C33.0444 22.5659 33.847 21.7488 33.847 20.7409V15.1609Z"
        fill="#F73753"
      />
      <path
        d="M3.58524 14.5828C3.58524 13.5749 2.78266 12.7578 1.79262 12.7578C0.802584 12.7578 0 13.5749 0 14.5828V20.1628C0 21.1707 0.802584 21.9877 1.79262 21.9877C2.78266 21.9877 3.58524 21.1707 3.58524 20.1628V14.5828Z"
        fill="#F73753"
      />
      <path
        d="M9.63603 17.7117C9.63603 16.7038 8.83344 15.8867 7.8434 15.8867C6.85337 15.8867 6.05078 16.7038 6.05078 17.7117V27.5141C6.05078 28.522 6.85337 29.3391 7.8434 29.3391C8.83344 29.3391 9.63603 28.522 9.63603 27.5141V17.7117Z"
        fill="#F73753"
      />
    </svg>
  );
}
